// Additional sections merged into the base terms — store obligations and regional frameworks.
export const TERMS_EXTRA_EN = [
  {
    h: "14. Store apps and no in-app purchases",
    p: [
      "The iOS and Android apps are free to download and contain no in-app purchase, no prices, no subscription buttons and no links to buy. Accounts are created by the employer, and employees never pay anything inside the app.",
      "Subscriptions are sold to companies only, under a separate business contract outside the stores. This is not presented as an incentive to purchase outside the store and is not surfaced inside the apps.",
      "This agreement is between you and HELCOO only. Neither Apple nor Google is a party to it, and neither bears any responsibility for the app, its content or its support. The End User License Agreement (EULA) applies in addition to these terms.",
    ],
  },
  {
    h: "15. Device permissions",
    p: [
      "Camera: only to verify your face at check-in or check-out. Location: \"While in Use\" only and only at the moment of a check, to confirm the branch geofence — there is no background tracking. Photos: optional, to pick a profile picture or company logo. Notifications: shift reminders and decisions on your requests.",
      "You may decline or withdraw any permission in your device's system settings; the app keeps working and only the related feature is unavailable.",
    ],
  },
  {
    h: "16. Age and eligibility",
    p: [
      "The service is intended for workplaces and for users aged 18 or over, or 16 where local employment law permits and with guardian and employer consent. We do not knowingly collect children's data, and if we learn that under-age data has been collected we delete it immediately.",
    ],
  },
  {
    h: "17. Regional regulatory compliance",
    p: [
      "The service is operated in line with the GDPR and UK GDPR, the Saudi Personal Data Protection Law (PDPL), the UAE Personal Data Protection Law, and California privacy law (CCPA/CPRA) — we do not sell or share your personal information within the meaning of those laws.",
      "The customer acknowledges that it is responsible for compliance with local employment and employee-monitoring law, including notifying employees and consulting their representatives where required.",
    ],
  },
  {
    h: "18. Availability and support",
    p: [
      "We target 99.5% monthly availability with maintenance windows announced in advance. Support is available at support@helcoo.uk with a target response time of two business days.",
      "The service may be affected by internet outages or infrastructure provider failures; we are not liable for causes outside our reasonable control.",
    ],
  },
  {
    h: "19. Dispute resolution",
    p: [
      "We will seek to resolve any dispute amicably within 30 days of written notice. Failing that, the courts of the United Kingdom have jurisdiction, without prejudice to your right as a consumer to bring proceedings in your country of residence.",
      "Nothing prevents either party from seeking urgent interim relief to protect its data or intellectual property rights.",
    ],
  },
];
